import { Grid } from "@mui/material";
import { AddAccountButton } from "Components/BankAccounts/BankAccountList/AddAccountButton";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { Resources, useResource } from "Translations/Resources";

const PageResources = Resources.Pages.Content.BankAccounts;

type Props = {
  hasMultipleAccounts: boolean;
  onSwitchToEditOrderRequested: () => void;
};

export const BankAccountListActions = ({
  hasMultipleAccounts,
  onSwitchToEditOrderRequested,
}: Props) => {
  const { t } = useResource();

  return (
    <Grid container spacing={4}>
      <Grid size={{ xs: 12, md: hasMultipleAccounts ? 7 : 12 }}>
        <AddAccountButton />
      </Grid>
      {hasMultipleAccounts && (
        <Grid size={{ xs: 12, md: 5 }}>
          <PrimaryButton
            fullWidth
            color="info"
            variant="outlined"
            onClick={onSwitchToEditOrderRequested}
          >
            {t(PageResources.EditOrder)}
          </PrimaryButton>
        </Grid>
      )}
    </Grid>
  );
};
